import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Login from "authentication/Index";
import NotFound from "components/NotFound";
import Dashboard from "Dashboard/Index";
import Carnets from "Dashboard/scenes/Carnets/Index";
import Incidents from "Dashboard/scenes/Incidents/Index";
import HumanResources from "Dashboard/scenes/HumanResources/Index";
import HighRiseSales from "Dashboard/scenes/HighRiseSales/Index";
import Partners from "Dashboard/scenes/Partners/Index";
import ConcreteBaseInput from "Dashboard/scenes/ConcreteBase/scenes/Input/Index";
import ConcreteBaseOutput from "Dashboard/scenes/ConcreteBase/scenes/Output/Index";
import StockInput from "Dashboard/scenes/Stock/secenes/Input/Index";
import StockOutput from "Dashboard/scenes/Stock/secenes/Output/Index";
import PrintPartners from "Dashboard/scenes/Partners/scenes/Main/components/PrintPartners";
import PrintStock from "Dashboard/scenes/Stock/secenes/Input/components/PrintStock";
import Projects from "Dashboard/scenes/Projects/Index";
import ConsumablesInput from "Dashboard/scenes/Consumables/scenes/Input/Index";
import ConsumablesOutput from "Dashboard/scenes/Consumables/scenes/Output/Index";
import Resources from "Dashboard/scenes/Resources/Index";
import DailyTable from "Dashboard/scenes/DailyTable/Index";
import Statistics from "Dashboard/scenes/Statistics/Index";
import { FullUser } from "authentication/domain/FullUser";
import PrivateRoute from "components/PrivateRoute";
import Expenses from "Dashboard/scenes/Expenses/Index";
import PrintOutput from "Dashboard/scenes/Consumables/scenes/Output/components/PrintOutput";

interface IProps {
  user?: FullUser;
};

const AllRoutes = ({ user }: IProps) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PrivateRoute><Navigate to="/dashboard" /></PrivateRoute>} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard user={user} />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/carnets"
          element={
            <PrivateRoute>
              <Carnets />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/incidents"
          element={
            <PrivateRoute>
              <Incidents />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/human-resources"
          element={
            <PrivateRoute>
              <HumanResources />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/high-rise-sales"
          element={
            <PrivateRoute>
              <HighRiseSales />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/partners"
          element={
            <PrivateRoute>
              <Partners />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/partners/print/:search"
          element={
            <PrivateRoute>
              <PrintPartners />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/betonska-baza"
          element={
            <PrivateRoute>
              <ConcreteBaseInput />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/betonska-baza/output"
          element={
            <PrivateRoute>
              <ConcreteBaseOutput />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/betonska-baza/output/print"
          element={
            <PrivateRoute>
              <PrintOutput />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/stock"
          element={
            <PrivateRoute>
              <StockInput />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/stock/output"
          element={
            <PrivateRoute>
              <StockOutput />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/stock/print"
          element={
            <PrivateRoute>
              <PrintStock />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/projects"
          element={
            <PrivateRoute>
              <Projects user={user} />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/consumables"
          element={
            <PrivateRoute>
              <ConsumablesInput />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/consumables/output"
          element={
            <PrivateRoute>
              <ConsumablesOutput />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/resources"
          element={
            <PrivateRoute>
              <Resources user={user} />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/daily-table"
          element={
            <PrivateRoute>
              <DailyTable />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/statistics"
          element={
            <PrivateRoute>
              <Statistics />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/expenses"
          element={
            <PrivateRoute>
              <Expenses />
            </PrivateRoute>
          }
        ></Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AllRoutes;
